import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from './supabase';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// ALTER TABLE seferler ADD COLUMN surucu_id uuid REFERENCES kullanicilar(id);
// ALTER TABLE seferler ADD COLUMN IF NOT EXISTS dagitimci_id uuid REFERENCES kullanicilar(id);

const ULKELER = [
  'KKTC', 'Montenegro', 'Türkiye',
  '---',
  'Afganistan', 'Almanya', 'Amerika Birleşik Devletleri', 'Arjantin', 'Arnavutluk',
  'Avustralya', 'Avusturya', 'Azerbaycan', 'Bahreyn', 'Belçika', 'Beyaz Rusya',
  'Bosna Hersek', 'Brezilya', 'Bulgaristan', 'Cezayir', 'Çek Cumhuriyeti', 'Çin',
  'Danimarka', 'Mısır', 'Emirati Arap Emirlikleri', 'Ermenistan', 'Estonya',
  'Etiyopya', 'Fas', 'Finlandiya', 'Fransa', 'Gürcistan', 'Hollanda', 'Hırvatistan',
  'Hindistan', 'Irak', 'İngiltere', 'İran', 'İrlanda', 'İspanya', 'İsrail',
  'İsveç', 'İsviçre', 'İtalya', 'İzlanda', 'Japonya', 'Kanada', 'Katar',
  'Kazakistan', 'Kenya', 'Kırgızistan', 'Kolombiya', 'Kosova', 'Kuveyt',
  'Kuzey Makedonya', 'Letonya', 'Lihtenştayn', 'Litvanya', 'Lübnan', 'Lüksemburg',
  'Macaristan', 'Malezya', 'Malta', 'Meksika', 'Moldova', 'Moğolistan',
  'Nijerya', 'Norveç', 'Özbekistan', 'Pakistan', 'Polonya', 'Portekiz',
  'Romanya', 'Rusya', 'Suudi Arabistan', 'Sırbistan', 'Singapur', 'Slovakya',
  'Slovenya', 'Sudan', 'Suriye', 'Tacikistan', 'Tayland', 'Tunus',
  'Türkmenistan', 'Ukrayna', 'Umman', 'Ürdün', 'Venezuela', 'Vietnam',
  'Yemen', 'Yunanistan', 'Yeni Zelanda'
];
// ALTER TABLE seferler ADD COLUMN IF NOT EXISTS tasima_sekli varchar DEFAULT 'Kara Yolu';

const TASIMA_SEKILLERI = [
  { deger: 'Kara Yolu',  ikon: '🚛' },
  { deger: 'Deniz Yolu', ikon: '🚢' },
  { deger: 'Hava Yolu',  ikon: '✈️' },
  { deger: 'Demiryolu',  ikon: '🚂' },
];

const tasimaIkonu = (sekil) => {
  const bulunan = TASIMA_SEKILLERI.find(t => t.deger === sekil);
  return bulunan ? bulunan.ikon : '🚛';
};

function TirSefer() {
  const [seferler, setSeferler]       = useState([]);
  const [suruculer, setSuruculer]     = useState([]);
  const [dagitimciler, setDagitimciler] = useState([]);
  const [yukleniyor, setYukleniyor]   = useState(true);
  const [formAcik, setFormAcik]       = useState(false);
  const [secilenSefer, setSecilenSefer] = useState(null);
  const [yeniSefer, setYeniSefer]     = useState({
    sefer_no: '', kalkisUlkesi: '', varisUlkesi: '', surucu_ad: '', surucu_id: '',
    plaka: '', durum: 'Yükleme Bekliyor', tahmini_varis: '', tasima_sekli: 'Kara Yolu'
  });
  const [duzenleSefer, setDuzenleSefer] = useState(null);
  const [aktifSekme, setAktifSekme]   = useState('aktif');
  const [guzergahFiltre, setGuzergahFiltre] = useState('Tümü');

  useEffect(() => { seferleriGetir(); suruculeriGetir(); dagitimcileriGetir(); }, []);

  const seferleriGetir = async () => {
    setYukleniyor(true);
    const { data, error } = await supabase
      .from('seferler').select('*').order('created_at', { ascending: false });
    if (!error) setSeferler(data);
    setYukleniyor(false);
  };

  const suruculeriGetir = async () => {
    const { data } = await supabase
      .from('kullanicilar')
      .select('id, ad')
      .eq('rol', 'surucu')
      .eq('durum', 'Aktif')
      .order('ad', { ascending: true });
    if (data) setSuruculer(data);
  };

  const dagitimcileriGetir = async () => {
    const { data } = await supabase
      .from('kullanicilar')
      .select('id, ad')
      .eq('rol', 'dagitimci')
      .order('ad', { ascending: true });
    if (data) setDagitimciler(data);
  };

  const formAc = async () => {
    const yil = new Date().getFullYear();
    const prefix = `TIR-${yil}-`;
    const { data } = await supabase
      .from('seferler')
      .select('sefer_no')
      .like('sefer_no', `${prefix}%`)
      .order('sefer_no', { ascending: false })
      .limit(1);
    let maxNo = 0;
    if (data && data.length > 0) {
      const parca = data[0].sefer_no.split('-');
      const no = parseInt(parca[parca.length - 1]);
      if (!isNaN(no)) maxNo = no;
    }
    const seferNo = `${prefix}${String(maxNo + 1).padStart(2, '0')}`;
    setYeniSefer({ sefer_no: seferNo, kalkisUlkesi: '', varisUlkesi: '', surucu_ad: '', surucu_id: '', plaka: '', durum: 'Yükleme Bekliyor', tahmini_varis: '', tasima_sekli: 'Kara Yolu' });
    setFormAcik(true);
  };

  const suruculerSecildi = (id, form, setForm) => {
    const secilen = suruculer.find(s => s.id === id);
    setForm({ ...form, surucu_id: id, surucu_ad: secilen ? secilen.ad : '' });
  };

  const seferEkle = async () => {
    const karaYolu = yeniSefer.tasima_sekli === 'Kara Yolu';
    if (karaYolu && !yeniSefer.surucu_ad) return alert('Sürücü seçimi zorunlu!');
    if (!yeniSefer.kalkisUlkesi) return alert('Kalkış ülkesi seçiniz!');
    if (!yeniSefer.varisUlkesi)  return alert('Varış ülkesi seçiniz!');
    const seferNo  = yeniSefer.sefer_no || seferNoOlustur();
    const guzergah = `${yeniSefer.kalkisUlkesi} → ${yeniSefer.varisUlkesi}`;
    const { kalkisUlkesi, varisUlkesi, ...geriKalan } = yeniSefer;
    const kayit = {
      ...geriKalan,
      sefer_no:  seferNo,
      guzergah,
      surucu_ad: karaYolu ? yeniSefer.surucu_ad : null,
      surucu_id: karaYolu ? (yeniSefer.surucu_id || null) : null,
      plaka:     karaYolu ? yeniSefer.plaka : null,
    };
    const { error } = await supabase.from('seferler').insert([kayit]);
    if (error) { alert('Hata: ' + error.message); }
    else {
      setFormAcik(false);
      setYeniSefer({ sefer_no: '', kalkisUlkesi: '', varisUlkesi: '', surucu_ad: '', surucu_id: '', plaka: '', durum: 'Yükleme Bekliyor', tahmini_varis: '', tasima_sekli: 'Kara Yolu' });
      seferleriGetir();
    }
  };

  const seferSil = async (id, seferNo) => {
    if (!window.confirm(`"${seferNo}" seferini silmek istediğinize emin misiniz?\n\nSefere atanmış mallar depoya geri dönecek.`)) return;

    // 1) sefer_musteriler bağlı kayıtlarını sil
    const { error: smError } = await supabase
      .from('sefer_musteriler').delete().eq('sefer_id', id);
    if (smError) { alert('Hata (sefer_musteriler): ' + smError.message); return; }

    // 2) odemeler bağlı kayıtlarını sil
    const { error: odError } = await supabase
      .from('odemeler').delete().eq('sefer_id', id);
    if (odError) { alert('Hata (odemeler): ' + odError.message); return; }

    // 3) gumruk_adimlar bağlı kayıtlarını sil
    const { error: gaError } = await supabase
      .from('gumruk_adimlar').delete().eq('sefer_id', id);
    if (gaError) { alert('Hata (gumruk_adimlar): ' + gaError.message); return; }

    // 4) Depodaki malları geri bırak (silme, depoya döndür)
    const { error: depoError } = await supabase
      .from('depo').update({ sefer_id: null, durum: 'Bekliyor' }).eq('sefer_id', id);
    if (depoError) { alert('Hata (depo): ' + depoError.message); return; }

    // 5) Seferi sil
    const { error } = await supabase.from('seferler').delete().eq('id', id);
    if (error) { alert('Hata: ' + error.message); return; }

    seferleriGetir();
  };

  const seferGuncelle = async () => {
    const karaYolu = (duzenleSefer.tasima_sekli || 'Kara Yolu') === 'Kara Yolu';
    if (karaYolu && !duzenleSefer.surucu_ad) return alert('Sürücü seçimi zorunlu!');
    const { error } = await supabase.from('seferler').update({
      guzergah:      duzenleSefer.guzergah,
      surucu_ad:     karaYolu ? duzenleSefer.surucu_ad : null,
      surucu_id:     karaYolu ? (duzenleSefer.surucu_id || null) : null,
      plaka:         karaYolu ? duzenleSefer.plaka : null,
      durum:         duzenleSefer.durum,
      tahmini_varis: duzenleSefer.tahmini_varis,
      tasima_sekli:  duzenleSefer.tasima_sekli || 'Kara Yolu',
    }).eq('id', duzenleSefer.id);
    if (error) { alert('Hata: ' + error.message); }
    else { setDuzenleSefer(null); seferleriGetir(); }
  };

  const durumRenk = (durum) => {
    switch(durum) {
      case 'Teslim Edildi': return { bg: '#EAF3DE', renk: '#3B6D11' };
      case 'Gümrükte': return { bg: '#FEF3C7', renk: '#854F0B' };
      case 'Yolda': return { bg: '#E6F1FB', renk: '#185FA5' };
      case 'Dağıtımda': return { bg: '#F3E8FF', renk: '#6B21A8' };
      default: return { bg: '#f1f1f1', renk: '#555' };
    }
  };

  if (secilenSefer) {
    return <SeferDetay sefer={secilenSefer} onGeri={() => setSecilenSefer(null)} durumRenk={durumRenk} dagitimciler={dagitimciler} />;
  }

  const kullaniciRol = (() => { try { return JSON.parse(localStorage.getItem('kullanici') || '{}').rol; } catch { return ''; } })();

  const filtrelenmisAktif  = seferler.filter(s => s.durum !== 'Teslim Edildi' && (guzergahFiltre === 'Tümü' || s.guzergah === guzergahFiltre));
  const filtrelenmisGecmis = seferler.filter(s => s.durum === 'Teslim Edildi'  && (guzergahFiltre === 'Tümü' || s.guzergah === guzergahFiltre));
  const gorunurSeferler    = aktifSekme === 'aktif' ? filtrelenmisAktif : filtrelenmisGecmis;

  return (
    <div style={{ flex: 1, background: '#f5f5f5', display: 'flex', flexDirection: 'column', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ background: '#fff', padding: '14px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: '18px', fontWeight: '600' }}>TIR / Sefer</div>
        {['yonetici', 'operasyon'].includes(kullaniciRol) && (
          <button onClick={() => formAcik ? setFormAcik(false) : formAc()}
            style={{ background: '#0D3B7A', color: '#fff', border: 'none', padding: '8px 18px', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '600' }}>
            {formAcik ? '✕ Kapat' : '+ Yeni Sefer'}
          </button>
        )}
      </div>

      <div style={{ padding: '24px' }}>
        {formAcik && (
          <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #ddd', padding: '20px', marginBottom: '20px' }}>
            <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '16px', color: '#0D3B7A' }}>Yeni Sefer Ekle</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '12px' }}>
              {/* Taşıma Şekli — en üstte, tam genişlik */}
              <div style={{ gridColumn: '1 / -1' }}>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Taşıma Şekli</div>
                <select value={yeniSefer.tasima_sekli}
                  onChange={e => setYeniSefer({ ...yeniSefer, tasima_sekli: e.target.value, surucu_ad: '', surucu_id: '', plaka: '' })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  {TASIMA_SEKILLERI.map(t => <option key={t.deger} value={t.deger}>{t.ikon} {t.deger}</option>)}
                </select>
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Sefer No</div>
                <div style={{ padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', background: '#f5f7fa', color: '#0D3B7A', fontWeight: '700' }}>
                  {yeniSefer.sefer_no}
                </div>
              </div>
              {yeniSefer.tasima_sekli === 'Kara Yolu' && (
                <div>
                  <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Sürücü *</div>
                  <select value={yeniSefer.surucu_id}
                    onChange={e => suruculerSecildi(e.target.value, yeniSefer, setYeniSefer)}
                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }}>
                    <option value="">— Sürücü Seçin —</option>
                    {suruculer.map(s => <option key={s.id} value={s.id}>{s.ad}</option>)}
                  </select>
                </div>
              )}
              {yeniSefer.tasima_sekli === 'Kara Yolu' && (
                <div>
                  <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Plaka</div>
                  <input value={yeniSefer.plaka} onChange={e => setYeniSefer({ ...yeniSefer, plaka: e.target.value })}
                    placeholder="33 ABC 001"
                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
                </div>
              )}
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Kalkış Ülkesi *</div>
                <select value={yeniSefer.kalkisUlkesi} onChange={e => setYeniSefer({ ...yeniSefer, kalkisUlkesi: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  <option value="">— Ülke Seçin —</option>
                  {ULKELER.map((u, i) => u === '---'
                    ? <option key={i} disabled>──────────────</option>
                    : <option key={i} value={u}>{u}</option>
                  )}
                </select>
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Varış Ülkesi *</div>
                <select value={yeniSefer.varisUlkesi} onChange={e => setYeniSefer({ ...yeniSefer, varisUlkesi: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  <option value="">— Ülke Seçin —</option>
                  {ULKELER.map((u, i) => u === '---'
                    ? <option key={i} disabled>──────────────</option>
                    : <option key={i} value={u}>{u}</option>
                  )}
                </select>
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Durum</div>
                <select value={yeniSefer.durum} onChange={e => setYeniSefer({ ...yeniSefer, durum: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  <option>Yükleme Bekliyor</option>
                  <option>Yüklendi</option>
                  <option>Yolda</option>
                  <option>Gümrükte</option>
                  <option>Dağıtımda</option>
                  <option>Teslim Edildi</option>
                </select>
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Tahmini Varış</div>
                <input type="date" value={yeniSefer.tahmini_varis} onChange={e => setYeniSefer({ ...yeniSefer, tahmini_varis: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button onClick={() => setFormAcik(false)} style={{ padding: '8px 18px', border: '1px solid #ddd', borderRadius: '6px', background: '#fff', cursor: 'pointer' }}>Vazgeç</button>
              <button onClick={seferEkle} style={{ padding: '8px 20px', background: '#0D3B7A', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' }}>Kaydet</button>
            </div>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '20px' }}>
          {[
            { label: 'Toplam Sefer', value: seferler.length },
            { label: 'Aktif Sefer', value: seferler.filter(s => s.durum !== 'Teslim Edildi').length },
            { label: 'Teslim Edilen', value: seferler.filter(s => s.durum === 'Teslim Edildi').length },
            { label: 'Gümrükte', value: seferler.filter(s => s.durum === 'Gümrükte').length },
          ].map((card, i) => (
            <div key={i} style={{ background: '#fff', borderRadius: '10px', padding: '16px', border: '1px solid #eee' }}>
              <div style={{ fontSize: '12px', color: '#888', marginBottom: '6px' }}>{card.label}</div>
              <div style={{ fontSize: '28px', fontWeight: '700', color: '#1a1a1a' }}>{card.value}</div>
            </div>
          ))}
        </div>

        <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #eee', overflow: 'hidden' }}>
          <div style={{ padding: '12px 20px', borderBottom: '1px solid #eee', display: 'flex', gap: '4px', alignItems: 'center', flexWrap: 'wrap' }}>
            {[
              { key: 'aktif', label: 'Aktif Seferler', count: seferler.filter(s => s.durum !== 'Teslim Edildi').length },
              { key: 'gecmis', label: 'Geçmiş Seferler', count: seferler.filter(s => s.durum === 'Teslim Edildi').length },
            ].map(sekme => (
              <button key={sekme.key} onClick={() => setAktifSekme(sekme.key)}
                style={{ padding: '6px 14px', borderRadius: '6px', border: 'none', cursor: 'pointer', fontSize: '13px', fontWeight: aktifSekme === sekme.key ? '600' : '400', background: aktifSekme === sekme.key ? '#0D3B7A' : '#f1f1f1', color: aktifSekme === sekme.key ? '#fff' : '#555' }}>
                {sekme.label} ({sekme.count})
              </button>
            ))}
            <div style={{ marginLeft: 'auto' }}>
              <select value={guzergahFiltre} onChange={e => setGuzergahFiltre(e.target.value)}
                style={{ padding: '6px 10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '12px', color: '#555' }}>
                <option value="Tümü">Tüm Güzergahlar</option>
                {[...new Set(seferler.map(s => s.guzergah).filter(Boolean))].sort().map(g => (
                  <option key={g} value={g}>{g}</option>
                ))}
              </select>
            </div>
          </div>
          {yukleniyor ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Yükleniyor...</div>
          ) : gorunurSeferler.length === 0 ? (
            <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>
              {guzergahFiltre !== 'Tümü' ? `"${guzergahFiltre}" güzergahında sefer yok.` : 'Sefer yok.'}
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#f9f9f9' }}>
                  {['Sefer No', 'Güzergah', 'Sürücü', 'Plaka', 'Durum', 'Tahmini Varış', ''].map((h, i) => (
                    <th key={i} style={{ padding: '10px 16px', textAlign: 'left', color: '#888', fontWeight: '500', fontSize: '12px' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {gorunurSeferler.map((row, i) => {
                  const { bg, renk } = durumRenk(row.durum);
                  return (
                    <tr key={i} style={{ borderTop: '1px solid #eee', cursor: 'pointer' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f9fbff'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <td style={{ padding: '12px 16px', fontWeight: '600', color: '#0D3B7A', cursor: 'pointer' }}
                        onClick={() => setSecilenSefer(row)}>
                        <span style={{ marginRight: '5px' }}>{tasimaIkonu(row.tasima_sekli)}</span>{row.sefer_no}
                      </td>
                      <td style={{ padding: '12px 16px' }}>{row.guzergah}</td>
                      <td style={{ padding: '12px 16px' }}>{row.surucu_ad}</td>
                      <td style={{ padding: '12px 16px', color: '#888' }}>{row.plaka}</td>
                      <td style={{ padding: '12px 16px' }}>
                        <span style={{ background: bg, color: renk, padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>{row.durum}</span>
                      </td>
                      <td style={{ padding: '12px 16px', color: '#888' }}>{row.tahmini_varis}</td>
                      <td style={{ padding: '12px 16px' }}>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <button onClick={e => { e.stopPropagation(); setDuzenleSefer({ ...row }); }}
                            style={{ background: 'none', border: '1px solid #ddd', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontSize: '13px', color: '#555' }}>
                            ✏️ Düzenle
                          </button>
                          <button onClick={e => { e.stopPropagation(); seferSil(row.id, row.sefer_no); }}
                            style={{ background: 'none', border: '1px solid #fcc', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontSize: '13px', color: '#cc0000' }}>
                            🗑️ Sil
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {duzenleSefer && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '520px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <div style={{ fontSize: '16px', fontWeight: '600', color: '#0D3B7A' }}>Sefer Düzenle — {duzenleSefer.sefer_no}</div>
              <button onClick={() => setDuzenleSefer(null)} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#888' }}>✕</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
              {/* Taşıma Şekli — tam genişlik, en üstte */}
              <div style={{ gridColumn: '1 / -1' }}>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Taşıma Şekli</div>
                <select value={duzenleSefer.tasima_sekli || 'Kara Yolu'}
                  onChange={e => setDuzenleSefer({ ...duzenleSefer, tasima_sekli: e.target.value, surucu_ad: '', surucu_id: '', plaka: '' })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  {TASIMA_SEKILLERI.map(t => <option key={t.deger} value={t.deger}>{t.ikon} {t.deger}</option>)}
                </select>
              </div>
              {(duzenleSefer.tasima_sekli || 'Kara Yolu') === 'Kara Yolu' && (
                <div>
                  <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Sürücü *</div>
                  <select value={duzenleSefer.surucu_id || ''}
                    onChange={e => suruculerSecildi(e.target.value, duzenleSefer, setDuzenleSefer)}
                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                    <option value="">— Sürücü Seçin —</option>
                    {suruculer.map(s => <option key={s.id} value={s.id}>{s.ad}</option>)}
                  </select>
                </div>
              )}
              {(duzenleSefer.tasima_sekli || 'Kara Yolu') === 'Kara Yolu' && (
                <div>
                  <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Plaka</div>
                  <input value={duzenleSefer.plaka || ''} onChange={e => setDuzenleSefer({ ...duzenleSefer, plaka: e.target.value })}
                    placeholder="33 ABC 001"
                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
                </div>
              )}
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Güzergah</div>
                <input value={duzenleSefer.guzergah || ''} onChange={e => setDuzenleSefer({ ...duzenleSefer, guzergah: e.target.value })}
                  placeholder="ör. Türkiye → KKTC"
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
              <div>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Durum</div>
                <select value={duzenleSefer.durum} onChange={e => setDuzenleSefer({ ...duzenleSefer, durum: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}>
                  <option>Yükleme Bekliyor</option>
                  <option>Yüklendi</option>
                  <option>Yolda</option>
                  <option>Gümrükte</option>
                  <option>Dağıtımda</option>
                  <option>Teslim Edildi</option>
                </select>
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <div style={{ fontSize: '12px', fontWeight: '500', marginBottom: '6px' }}>Tahmini Varış</div>
                <input type="date" value={duzenleSefer.tahmini_varis || ''} onChange={e => setDuzenleSefer({ ...duzenleSefer, tahmini_varis: e.target.value })}
                  style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setDuzenleSefer(null)} style={{ padding: '8px 18px', border: '1px solid #ddd', borderRadius: '6px', background: '#fff', cursor: 'pointer' }}>İptal</button>
              <button onClick={seferGuncelle} style={{ padding: '8px 20px', background: '#0D3B7A', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' }}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── DETAY SAYFASI ──────────────────────────────────────────
function SeferDetay({ sefer, onGeri, durumRenk, dagitimciler = [] }) {
  const [seferMallari, setSeferMallari] = useState([]);
  const [durumModal, setDurumModal]     = useState(false);
  const [yeniDurum, setYeniDurum]       = useState(sefer.durum);
  const [not, setNot]                   = useState('');
  const [secilenDagitimciId, setSecilenDagitimciId]     = useState(sefer.dagitimci_id || '');
  const [dagitimciKaydediliyor, setDagitimciKaydediliyor] = useState(false);
  const [dagitimciAtandi, setDagitimciAtandi]             = useState(false);
  const [kargoDetayModal, setKargoDetayModal] = useState(null); // { musteriId, musteriAd }
  const [kargoDetaylari, setKargoDetaylari]   = useState([]);
  const [kargoYukleniyor, setKargoYukleniyor] = useState(false);

  const seferMallariniGetir = useCallback(async () => {
    const { data } = await supabase
      .from('depo')
      .select('*, musteriler(ad, sehir)')
      .eq('sefer_id', sefer.id);
    if (data) setSeferMallari(data);
  }, [sefer.id]);

  useEffect(() => {
    seferMallariniGetir();
  }, [seferMallariniGetir]);

  const malGeriAl = async (malId) => {
    if (!window.confirm('Bu malı seferden geri almak istediğinize emin misiniz?')) return;
    await supabase.from('depo')
      .update({ durum: 'Bekliyor', sefer_id: null })
      .eq('id', malId);
    seferMallariniGetir();
  };

  const durumGuncelle = async () => {
    await supabase.from('seferler').update({ durum: yeniDurum }).eq('id', sefer.id);
    if (yeniDurum === 'Teslim Edildi') {
      await supabase.from('depo').update({ durum: 'Teslim Edildi' }).eq('sefer_id', sefer.id);
    }
    sefer.durum = yeniDurum;
    setDurumModal(false);
    seferMallariniGetir();
  };

  const dagitimciAta = async () => {
    if (!secilenDagitimciId) return;
    setDagitimciKaydediliyor(true);
    const { error } = await supabase
      .from('seferler')
      .update({ dagitimci_id: secilenDagitimciId })
      .eq('id', sefer.id);
    if (error) { alert('Hata: ' + error.message); }
    else {
      sefer.dagitimci_id = secilenDagitimciId;
      setDagitimciAtandi(true);
    }
    setDagitimciKaydediliyor(false);
  };

  // ── Yetki kontrolü ──────────────────────────────────────────
  const kullaniciRol = (() => { try { return JSON.parse(localStorage.getItem('kullanici') || '{}').rol; } catch { return ''; } })();
  const yetkili = ['yonetici', 'operasyon'].includes(kullaniciRol);

  // ── Müşteri kargo detaylarını getir ─────────────────────────
  const musteriKargolariniGetir = async (musteriId, musteriAd) => {
    setKargoYukleniyor(true);
    setKargoDetaylari([]);
    setKargoDetayModal({ musteriId, musteriAd });
    const { data } = await supabase
      .from('depo')
      .select('*, musteriler(ad)')
      .eq('musteri_id', musteriId)
      .eq('sefer_id', sefer.id);
    if (data) setKargoDetaylari(data);
    setKargoYukleniyor(false);
  };

  const manifestoIndir = () => {
    // jsPDF standart fontlar Türkçe karakter desteklemez — ASCII karşılıklarına çevir
    const tr = (s) => {
      if (s == null) return '';
      return String(s)
        .replace(/İ/g, 'I').replace(/ı/g, 'i')
        .replace(/Ş/g, 'S').replace(/ş/g, 's')
        .replace(/Ğ/g, 'G').replace(/ğ/g, 'g')
        .replace(/Ü/g, 'U').replace(/ü/g, 'u')
        .replace(/Ö/g, 'O').replace(/ö/g, 'o')
        .replace(/Ç/g, 'C').replace(/ç/g, 'c')
        .replace(/→/g, '->');
    };

    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const bugün = new Date().toLocaleDateString('tr-TR');
    const L = 14, R = pageW - 14;

    // ════════════ BAŞLIK ════════════
    doc.setFillColor(13, 59, 122);
    doc.rect(0, 0, pageW, 30, 'F');

    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(18);
    doc.text('BYR SWORD LOJISTIK', pageW / 2, 12, { align: 'center' });

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(180, 205, 240);
    doc.text('SEFER MANIFESTOSU', pageW / 2, 20, { align: 'center' });

    // sağ üst bilgi (başlık içinde)
    doc.setFontSize(8);
    doc.setTextColor(220, 230, 245);
    doc.text(`Tarih: ${bugün}`, R, 10, { align: 'right' });
    doc.text(`Sefer No: ${tr(sefer.sefer_no)}`, R, 17, { align: 'right' });

    // ════════════ SEFER BİLGİLERİ KUTUSU ════════════
    const boxY = 36, boxH = 34;
    doc.setFillColor(247, 249, 252);
    doc.setDrawColor(210, 220, 235);
    doc.setLineWidth(0.3);
    doc.roundedRect(L, boxY, R - L, boxH, 2, 2, 'FD');

    // Kutu başlığı
    doc.setFillColor(13, 59, 122);
    doc.roundedRect(L, boxY, R - L, 7, 2, 2, 'F');
    doc.rect(L, boxY + 3, R - L, 4, 'F'); // alt köşeleri düzelt
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(255, 255, 255);
    doc.text('SEFER BILGILERI', L + 4, boxY + 5);

    const col1X = L + 4, col2X = L + 42, col3X = pageW / 2 + 4, col4X = pageW / 2 + 38;
    const satirlar2 = [
      ['Sefer No:', tr(sefer.sefer_no), 'Guzergah:', tr(sefer.guzergah)],
      ['Surucu:', tr(sefer.surucu_ad), 'Plaka:', tr(sefer.plaka)],
      ['Tahmini Varis:', tr(sefer.tahmini_varis) || '-', 'Durum:', tr(sefer.durum)],
    ];

    let ky = boxY + 14;
    doc.setFontSize(8.5);
    satirlar2.forEach(([k1, v1, k2, v2]) => {
      doc.setFont('helvetica', 'bold'); doc.setTextColor(90, 100, 120);
      doc.text(k1, col1X, ky);
      doc.setFont('helvetica', 'normal'); doc.setTextColor(20, 20, 20);
      doc.text(v1, col2X, ky);
      doc.setFont('helvetica', 'bold'); doc.setTextColor(90, 100, 120);
      doc.text(k2, col3X, ky);
      doc.setFont('helvetica', 'normal'); doc.setTextColor(20, 20, 20);
      doc.text(v2, col4X, ky);
      ky += 7;
    });

    // ════════════ YUKLER TABLOSU ════════════
    const tableStartY = boxY + boxH + 8;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.setTextColor(13, 59, 122);
    doc.text('YUKLER', L, tableStartY - 2);
    doc.setDrawColor(13, 59, 122);
    doc.setLineWidth(0.5);
    doc.line(L, tableStartY, R, tableStartY);

    // Şehre göre grupla → alfabetik → her grup içinde müşteri adına göre sırala
    const siraliMallar = [...seferMallari].sort((a, b) => {
      const sehirA = (a.musteriler?.sehir || '').trim();
      const sehirB = (b.musteriler?.sehir || '').trim();
      // Şehri boş olanlar en sona
      if (!sehirA && sehirB)  return 1;
      if (sehirA && !sehirB)  return -1;
      // Şehre göre alfabetik
      const sehirKarsilastir = tr(sehirA).localeCompare(tr(sehirB));
      if (sehirKarsilastir !== 0) return sehirKarsilastir;
      // Aynı şehirde müşteri adına göre alfabetik
      return tr(a.musteriler?.ad || '').localeCompare(tr(b.musteriler?.ad || ''));
    });

    const tableRows = siraliMallar.map((mal, i) => [
      i + 1,
      tr(mal.musteriler?.ad) || '-',
      tr(mal.urun) || '-',
      tr(mal.miktar) || '-',
      mal.agirlik ? String(mal.agirlik) : '-',
      tr(mal.musteriler?.sehir) || '-',
    ]);

    autoTable(doc, {
      startY: tableStartY + 2,
      head: [['#', 'Musteri Adi', 'Urun / Aciklama', 'Miktar', 'Agirlik (kg)', 'Sehir']],
      body: tableRows,
      styles: {
        fontSize: 9,
        cellPadding: { top: 4, bottom: 4, left: 3, right: 3 },
        textColor: [30, 30, 30],
        lineColor: [220, 225, 235],
        lineWidth: 0.2,
      },
      headStyles: {
        fillColor: [13, 59, 122],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        fontSize: 8.5,
      },
      alternateRowStyles: { fillColor: [248, 250, 254] },
      columnStyles: {
        0: { cellWidth: 12, halign: 'center', overflow: 'hidden' },
        1: { cellWidth: 38 },
        2: { cellWidth: 'auto' },
        3: { cellWidth: 22 },
        4: { cellWidth: 24, halign: 'right' },
        5: { cellWidth: 26 },
      },
      margin: { left: L, right: L },
    });

    // ════════════ ÖZET SATIRI ════════════
    const sonY = doc.lastAutoTable.finalY;
    const toplamAgirlik = seferMallari.reduce((t, m) => t + (parseFloat(m.agirlik) || 0), 0);

    doc.setFillColor(236, 242, 252);
    doc.setDrawColor(210, 220, 235);
    doc.setLineWidth(0.2);
    doc.rect(L, sonY, R - L, 10, 'FD');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8.5);
    doc.setTextColor(13, 59, 122);
    doc.text(`Toplam Kalem: ${seferMallari.length}`, L + 4, sonY + 6.5);
    doc.text(`Toplam Agirlik: ${toplamAgirlik.toFixed(1)} kg`, L + 55, sonY + 6.5);

    // ════════════ İMZA ALANI ════════════
    const imzaY = Math.max(sonY + 24, pageH - 42);
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);

    // Sol imza kutusu
    doc.setFillColor(250, 251, 253);
    doc.rect(L, imzaY, 72, 26, 'FD');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(13, 59, 122);
    doc.text('SURUCU IMZASI', L + 36, imzaY + 6, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(80, 80, 80);
    doc.setFontSize(7.5);
    doc.text(tr(sefer.surucu_ad) || '', L + 36, imzaY + 12, { align: 'center' });
    doc.setDrawColor(150, 150, 150);
    doc.line(L + 8, imzaY + 22, L + 64, imzaY + 22);

    // Sağ imza kutusu
    doc.setFillColor(250, 251, 253);
    doc.setDrawColor(200, 200, 200);
    doc.rect(R - 72, imzaY, 72, 26, 'FD');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.setTextColor(13, 59, 122);
    doc.text('YETKILI IMZASI', R - 36, imzaY + 6, { align: 'center' });
    doc.setDrawColor(150, 150, 150);
    doc.line(R - 64, imzaY + 22, R - 8, imzaY + 22);

    // ════════════ FOOTER ════════════
    doc.setFillColor(13, 59, 122);
    doc.rect(0, pageH - 8, pageW, 8, 'F');
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7);
    doc.setTextColor(180, 205, 240);
    doc.text('BYR SWORD LOJISTIK  |  Bu belge otomatik olusturulmustur.', pageW / 2, pageH - 3, { align: 'center' });

    const dosyaAdi = `Manifesto_${sefer.sefer_no}_${bugün.replace(/\./g, '-')}.pdf`;
    doc.save(dosyaAdi);
  };

  const { bg, renk } = durumRenk(sefer.durum);

  return (
    <div style={{ flex: 1, background: '#f5f5f5', display: 'flex', flexDirection: 'column', fontFamily: 'Arial, sans-serif' }}>
      <div style={{ background: '#fff', padding: '14px 24px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button onClick={onGeri} style={{ background: 'none', border: 'none', color: '#0D3B7A', cursor: 'pointer', fontSize: '18px' }}>←</button>
          <span style={{ color: '#888', fontSize: '13px' }}>TIR / Sefer</span>
          <span style={{ color: '#888' }}>›</span>
          <span style={{ fontWeight: '600', fontSize: '14px' }}>{sefer.sefer_no}</span>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={manifestoIndir}
            style={{ background: '#fff', color: '#0D3B7A', border: '1.5px solid #0D3B7A', padding: '8px 16px', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '600' }}>
            📄 Manifesto İndir
          </button>
          <button onClick={() => setDurumModal(true)}
            style={{ background: '#0D3B7A', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', fontWeight: '600' }}>
            Durum Güncelle
          </button>
        </div>
      </div>

      <div style={{ padding: '24px', maxWidth: '700px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

          <div style={{ background: '#0D3B7A', borderRadius: '10px', padding: '20px', color: '#fff' }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
              <div>
                <div style={{ fontSize: '11px', color: '#a0b4d0', marginBottom: '4px' }}>SEFER NO</div>
                <div style={{ fontWeight: '700', fontSize: '16px' }}>{sefer.sefer_no}</div>
                <div style={{ fontSize: '12px', color: '#a0b4d0', marginTop: '2px' }}>{sefer.plaka}</div>
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#a0b4d0', marginBottom: '4px' }}>GÜZERGAH</div>
                <div style={{ fontWeight: '600' }}>{sefer.guzergah}</div>
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#a0b4d0', marginBottom: '4px' }}>DURUM</div>
                <span style={{ background: bg, color: renk, padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '600' }}>{sefer.durum}</span>
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#a0b4d0', marginBottom: '4px' }}>TAHMİNİ VARIŞ</div>
                <div style={{ fontWeight: '600' }}>{sefer.tahmini_varis || '—'}</div>
              </div>
              <div style={{ gridColumn: '1 / -1', borderTop: '1px solid rgba(255,255,255,0.15)', paddingTop: '14px' }}>
                <div style={{ fontSize: '11px', color: '#a0b4d0', marginBottom: '6px' }}>TOPLAM YÜK</div>
                <div style={{ fontWeight: '700', fontSize: '18px' }}>
                  {seferMallari.length} kalem
                  {' / '}
                  {seferMallari.reduce((t, m) => t + (parseFloat(m.agirlik) || 0), 0).toLocaleString('tr-TR')} kg
                </div>
              </div>
            </div>
          </div>

          <div style={{ background: '#fff', borderRadius: '10px', padding: '20px', border: '1px solid #eee' }}>
            <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '16px' }}>Sürücü</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '50%', background: '#0D3B7A', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: '700' }}>
                {sefer.surucu_ad ? sefer.surucu_ad.charAt(0) : '?'}
              </div>
              <div>
                <div style={{ fontWeight: '600' }}>{sefer.surucu_ad}</div>
                <div style={{ fontSize: '12px', color: '#888' }}>{sefer.plaka}</div>
              </div>
            </div>
          </div>

          {sefer.durum === 'Dağıtımda' && (
            <div style={{ background: '#fff', borderRadius: '10px', padding: '20px', border: '1px solid #eee' }}>
              <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '14px' }}>Dağıtımcı Ata</div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <select
                  value={secilenDagitimciId}
                  onChange={e => { setSecilenDagitimciId(e.target.value); setDagitimciAtandi(false); }}
                  style={{ flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px' }}
                >
                  <option value="">— Dağıtımcı Seçin —</option>
                  {dagitimciler.map(d => <option key={d.id} value={d.id}>{d.ad}</option>)}
                </select>
                <button
                  onClick={dagitimciAta}
                  disabled={dagitimciKaydediliyor || !secilenDagitimciId}
                  style={{
                    padding: '8px 18px', background: '#0D3B7A', color: '#fff',
                    border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600',
                    cursor: (dagitimciKaydediliyor || !secilenDagitimciId) ? 'default' : 'pointer',
                    opacity: (dagitimciKaydediliyor || !secilenDagitimciId) ? 0.55 : 1,
                  }}
                >
                  {dagitimciKaydediliyor ? 'Kaydediliyor…' : 'Ata'}
                </button>
              </div>
              {dagitimciAtandi && (
                <div style={{ marginTop: '10px', fontSize: '13px', color: '#16A34A', fontWeight: '600' }}>
                  ✓ Dağıtımcı atandı: {dagitimciler.find(d => d.id === secilenDagitimciId)?.ad}
                </div>
              )}
              {dagitimciler.length === 0 && (
                <div style={{ marginTop: '8px', fontSize: '12px', color: '#aaa' }}>
                  Sistemde kayıtlı dağıtımcı bulunamadı.
                </div>
              )}
            </div>
          )}

          <div style={{ background: '#fff', borderRadius: '10px', border: '1px solid #eee', overflow: 'hidden' }}>
            <div style={{ padding: '14px 20px', borderBottom: '1px solid #eee' }}>
              <div style={{ fontSize: '14px', fontWeight: '600' }}>
                Bu Seferdeki Mallar ({seferMallari.length})
              </div>
            </div>
            {seferMallari.length === 0 ? (
              <div style={{ color: '#888', fontSize: '13px', textAlign: 'center', padding: '24px 0' }}>
                Bu sefere henüz mal atanmadı. Depo sayfasından TIR'a Ata ile ekleyebilirsiniz.
              </div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: '#f9f9f9' }}>
                    {['Müşteri', 'Ürün', 'Miktar', 'Ağırlık', 'Fatura No', ''].map((h, i) => (
                      <th key={i} style={{ padding: '8px 16px', textAlign: 'left', color: '#888', fontWeight: '500', fontSize: '12px' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {seferMallari.map((mal, i) => (
                    <tr key={i} style={{ borderTop: '1px solid #f0f0f0' }}>
                      <td style={{ padding: '10px 16px', fontWeight: '500' }}>
                        {yetkili && mal.musteri_id ? (
                          <span
                            onClick={() => musteriKargolariniGetir(mal.musteri_id, mal.musteriler?.ad || '—')}
                            onMouseEnter={e => { e.currentTarget.style.color = '#185FA5'; e.currentTarget.style.textDecoration = 'underline'; }}
                            onMouseLeave={e => { e.currentTarget.style.color = '#0D3B7A'; e.currentTarget.style.textDecoration = 'none'; }}
                            style={{ cursor: 'pointer', color: '#0D3B7A', textDecoration: 'none', fontWeight: '600' }}
                          >
                            {mal.musteriler?.ad || '—'} <span style={{ fontSize: '11px', opacity: 0.7 }}>📦</span>
                          </span>
                        ) : (
                          mal.musteriler?.ad || '—'
                        )}
                      </td>
                      <td style={{ padding: '10px 16px' }}>{mal.urun}</td>
                      <td style={{ padding: '10px 16px', color: '#888' }}>{mal.miktar || '—'}</td>
                      <td style={{ padding: '10px 16px', color: '#888' }}>{mal.agirlik ? `${mal.agirlik} kg` : '—'}</td>
                      <td style={{ padding: '10px 16px', color: '#888', fontSize: '12px' }}>{mal.fatura_no || '—'}</td>
                      <td style={{ padding: '10px 16px' }}>
                        <button onClick={() => malGeriAl(mal.id)}
                          style={{ background: 'none', border: '1px solid #fcc', borderRadius: '5px', padding: '3px 8px', color: '#cc0000', cursor: 'pointer', fontSize: '12px' }}>
                          Geri Al
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>

      {/* ── Müşteri Kargo Detay Modalı ── */}
      {kargoDetayModal && (
        <div
          onClick={() => setKargoDetayModal(null)}
          style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '16px' }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{ background: '#fff', borderRadius: '12px', width: '100%', maxWidth: '560px', maxHeight: '85vh', display: 'flex', flexDirection: 'column', boxShadow: '0 8px 32px rgba(0,0,0,0.18)' }}
          >
            {/* Modal başlık */}
            <div style={{ padding: '18px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
              <div>
                <div style={{ fontSize: '15px', fontWeight: '700', color: '#0D3B7A' }}>
                  {kargoDetayModal.musteriAd}
                </div>
                <div style={{ fontSize: '12px', color: '#888', marginTop: '2px' }}>Kargo Detayları · {sefer.sefer_no}</div>
              </div>
              <button
                onClick={() => setKargoDetayModal(null)}
                style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#888', lineHeight: 1, padding: '4px' }}
              >✕</button>
            </div>

            {/* Modal içerik */}
            <div style={{ overflowY: 'auto', padding: '16px 20px', flex: 1 }}>
              {kargoYukleniyor ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#888', fontSize: '13px' }}>Yükleniyor...</div>
              ) : kargoDetaylari.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#888', fontSize: '13px' }}>
                  Bu müşteriye ait kargo kaydı bulunamadı.
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {kargoDetaylari.map((k, i) => {
                    const kargoDurumRenk = k.durum === 'Teslim Edildi'
                      ? { bg: '#EAF3DE', renk: '#3B6D11' }
                      : k.durum === "TIR'a Atandı"
                        ? { bg: '#E6F1FB', renk: '#185FA5' }
                        : { bg: '#f1f1f1', renk: '#555' };
                    return (
                      <div key={k.id || i} style={{ border: '1px solid #e8e8e8', borderRadius: '10px', padding: '16px', background: '#fafbff' }}>
                        {/* Kart üst: ürün + durum */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                          <div style={{ fontWeight: '700', fontSize: '14px', color: '#1a1a1a', flex: 1, marginRight: '10px' }}>
                            {k.urun || '—'}
                          </div>
                          <span style={{ background: kargoDurumRenk.bg, color: kargoDurumRenk.renk, padding: '3px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: '700', flexShrink: 0 }}>
                            {k.durum}
                          </span>
                        </div>

                        {/* Takip kodu — belirgin */}
                        {k.takip_kodu && (
                          <div style={{ marginBottom: '12px', padding: '8px 12px', background: '#EFF6FF', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: '10px', color: '#6b8cba', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Takip Kodu</span>
                            <span style={{ fontFamily: 'monospace', fontSize: '14px', fontWeight: '800', color: '#0D3B7A', letterSpacing: '1px' }}>
                              {k.takip_kodu}
                            </span>
                          </div>
                        )}

                        {/* Detay ızgara */}
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '13px' }}>
                          {k.miktar && (
                            <div>
                              <div style={{ fontSize: '11px', color: '#999', marginBottom: '2px' }}>Miktar</div>
                              <div style={{ fontWeight: '500' }}>{k.miktar}</div>
                            </div>
                          )}
                          {k.agirlik && (
                            <div>
                              <div style={{ fontSize: '11px', color: '#999', marginBottom: '2px' }}>Ağırlık</div>
                              <div style={{ fontWeight: '500' }}>{k.agirlik} kg</div>
                            </div>
                          )}
                          {k.hedef_ulke && (
                            <div>
                              <div style={{ fontSize: '11px', color: '#999', marginBottom: '2px' }}>Hedef Ülke</div>
                              <div style={{ fontWeight: '500' }}>{k.hedef_ulke}</div>
                            </div>
                          )}
                          {k.fatura_no && (
                            <div>
                              <div style={{ fontSize: '11px', color: '#999', marginBottom: '2px' }}>Fatura No</div>
                              <div style={{ fontWeight: '500', fontFamily: 'monospace', fontSize: '12px' }}>{k.fatura_no}</div>
                            </div>
                          )}
                          {k.irsaliye_no && (
                            <div>
                              <div style={{ fontSize: '11px', color: '#999', marginBottom: '2px' }}>İrsaliye No</div>
                              <div style={{ fontWeight: '500', fontFamily: 'monospace', fontSize: '12px' }}>{k.irsaliye_no}</div>
                            </div>
                          )}
                          {k.gonderici_firma && (
                            <div>
                              <div style={{ fontSize: '11px', color: '#999', marginBottom: '2px' }}>Gönderici Firma</div>
                              <div style={{ fontWeight: '500' }}>{k.gonderici_firma}</div>
                            </div>
                          )}
                        </div>

                        {/* Notlar */}
                        {k.notlar && (
                          <div style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #eee', fontSize: '12px', color: '#666' }}>
                            <span style={{ fontWeight: '600' }}>Not: </span>{k.notlar}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Modal alt */}
            <div style={{ padding: '12px 20px', borderTop: '1px solid #eee', flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '12px', color: '#888' }}>
                {kargoDetaylari.length > 0 && `${kargoDetaylari.length} kargo kaydı`}
              </span>
              <button
                onClick={() => setKargoDetayModal(null)}
                style={{ padding: '8px 20px', background: '#0D3B7A', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: '600', fontSize: '13px' }}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Durum Güncelle Modal */}
      {durumModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: '12px', padding: '24px', width: '420px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
              <div>
                <div style={{ fontSize: '16px', fontWeight: '600' }}>Durum Güncelle</div>
                <div style={{ fontSize: '12px', color: '#888' }}>{sefer.sefer_no} · {sefer.guzergah}</div>
              </div>
              <button onClick={() => setDurumModal(false)} style={{ background: 'none', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#888' }}>✕</button>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <div style={{ fontSize: '13px', fontWeight: '500', marginBottom: '10px' }}>Yeni Durum</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                {['Yükleme Bekliyor', 'Yüklendi', 'Yolda', 'Gümrükte', 'Dağıtımda', 'Teslim Edildi'].map(d => (
                  <div key={d} onClick={() => setYeniDurum(d)}
                    style={{ padding: '10px', borderRadius: '8px', border: `2px solid ${yeniDurum === d ? '#0D3B7A' : '#eee'}`, cursor: 'pointer', fontSize: '13px', background: yeniDurum === d ? '#f0f4ff' : '#fff', fontWeight: yeniDurum === d ? '600' : '400' }}>
                    {d}
                  </div>
                ))}
              </div>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <div style={{ fontSize: '13px', fontWeight: '500', marginBottom: '6px' }}>Not (isteğe bağlı)</div>
              <textarea value={not} onChange={e => setNot(e.target.value)} rows={3}
                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box', resize: 'none' }}
                placeholder="Açıklama ekle..." />
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button onClick={() => setDurumModal(false)} style={{ padding: '8px 18px', border: '1px solid #ddd', borderRadius: '6px', background: '#fff', cursor: 'pointer' }}>İptal</button>
              <button onClick={durumGuncelle} style={{ padding: '8px 20px', background: '#0D3B7A', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600' }}>Güncelle</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TirSefer;